// AI生视频
import AIGeneratedVideosIndex from '@/views/smartLife/AIGeneratedVideos/index'

const jmRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `AIGeneratedVideos/jm/index${i + 1}`,
  name: `AIGeneratedVideos/jm/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedVideos/jm/index${i + 1}.vue`)
}))
const branch1jmRoutes = Array.from({ length: 7 }, (_, i) => ({
  path: `AIGeneratedVideos/jm/branch1/index${i + 1}`,
  name: `AIGeneratedVideos/jm/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedVideos/jm/branch1/index${i + 1}.vue`)
}))

const dbRoutes = Array.from({ length: 13 }, (_, i) => ({
  path: `AIGeneratedVideos/db/index${i + 1}`,
  name: `AIGeneratedVideos/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedVideos/db/index${i + 1}.vue`)
}))
const branch1DbRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `AIGeneratedVideos/db/branch1/index${i + 1}`,
  name: `AIGeneratedVideos/db/branch1/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIGeneratedVideos/db/branch1/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'AIGeneratedVideos/index',
      name: 'AIGeneratedVideosIndex',
      component: AIGeneratedVideosIndex
    },
    // AI生视频，开始
    ...jmRoutes,
    ...branch1jmRoutes,
    ...dbRoutes,
    ...branch1DbRoutes
    // AI生视频，结束

  ]
}
